import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';

import { StyledTab as Tab } from '@process-advisor/process-miner/navigation/topBar/tab'
import { StyledTabs as Tabs } from '@process-advisor/process-miner/navigation/horizontalTabs/tabs';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

const Container = styled.div`
    max-height: 100px;
    margin-bottom: 10px;
`;

type Props = {
    onChange: (value: number) => void,
    activeTab: number
};

export const Navigation: React.FC<Props> = ({ onChange, activeTab }) => {
    const handleChange = (__, newValue: number) => onChange(newValue);
    const taskSummaryLabel = apiProvider.getEntityUpper() + ' Summary'
    const taskLabel = apiProvider.getEntityUpper() + 's'

    return (
        <Container>
            <Tabs
                value={activeTab}
                onChange={handleChange}>
                <Tab key={'Tasks'} label={taskLabel}></Tab>
                <Tab key={'Task Summary'} label={taskSummaryLabel}></Tab>
            </Tabs>
        </Container>
    );
};

